import { useQuery } from "@tanstack/react-query";
import { Navigate, Outlet } from "react-router-dom";
import { api, ApiError } from "../lib/api.js";

export function AuthGuard() {
  const { isLoading, error } = useQuery({
    queryKey: ["admin-me"],
    queryFn: () => api<{ chatId: string; username: string | null; role: string }>("/admin/auth/me"),
    retry: false,
  });

  if (isLoading) {
    return <div style={{ padding: 24, color: "var(--mnp-fg-3)" }}>Загрузка…</div>;
  }
  if (error) {
    if (error instanceof ApiError && (error.status === 401 || error.status === 403)) {
      return <Navigate to="/login" replace />;
    }
    return <div style={{ padding: 24, color: "var(--mnp-fg-3)" }}>Ошибка соединения. Попробуйте перезагрузить страницу.</div>;
  }

  return <Outlet />;
}
